import IAction from "../../types/IAction";
import { readMessageBack } from "../../utils/readMessageBack";
import actionTypes from "../actionTypes";
import MembresiaMetaCarga from "../../types/MembresiaMetaCarga";
import MembresiaPlantilla from "../../types/MembresiaPlantilla";
import MembresiaTrackingClub from "../../types/MembresiaTrackingClub";
import MembresiaTrackingClubAlcance from "../../types/MembresiaTrackingClubAlcance";
import ComisionAlcance from "../../types/ComisionAlcance";
import MembresiaProceso from "../../types/MembresiaProceso";
import { Result } from "../../types/Result";
import EmpleadoBaja from "../../types/EmpleadoBaja";
import MembresiaIntegranteAlta from "../../types/MembresiaIntegranteAlta";
import MembresiaIntegranteEliminado from "../../types/MembresiaIntegranteEliminado";

export interface PostComisionMembresiaCargaMetas {
  cargaMembresiaMeta: MembresiaMetaCarga;
  postingCargaMembresiaMeta: boolean;
  postingCargaMembresiaMetaError: string;
}

export interface GetComisionMembresiaMetas {
  comisionMembresiaMetas: MembresiaMetaCarga;
  gettingComisionMembresiaMetas: boolean;
  gettingComisionMembresiaMetasError: string;
}

export interface GetComisionMembresiaMetasActuales {
  comisionMembresiaMetasActuales: MembresiaMetaCarga;
  gettingComisionMembresiaMetasActuales: boolean;
  gettingComisionMembresiaMetasActualesError: string;
}

export interface GetComisionMembresiaPlantilla {
  comisionMembresiaPlantilla: MembresiaPlantilla;
  gettingComisionMembresiaPlantilla: boolean;
  gettingComisionMembresiaPlantillaError: string;
}

export interface PostComisionMembresiaPlantilla {
  plantillaGuardada: MembresiaPlantilla;
  postingComisionMembresiaPlantilla: boolean;
  postingComisionMembresiaPlantillaError: string;
}

export interface PostComisionMembresiaPlantillaConfirmar {
  plantillaConfirmada: boolean;
  postingComisionMembresiaPlantillaConfirmar: boolean;
  postingComisionMembresiaPlantillaConfirmarError: string;
}

export interface DeleteComisionMembresiaPlantilla {
  plantillaEliminada: boolean;
  deletingComisionMembresiaPlantilla: boolean;
  deletingComisionMembresiaPlantillaError: string;
}

export interface GetComisionMembresiaEmpleadosBaja {
  empleadosDadosDeBaja: EmpleadoBaja[];
  gettingEmpleadosDadosDeBaja: boolean;
  gettingEmpleadosDadosDeBajaError: string;
}

export interface DeleteComisionMembresiaPagoAnticipado {
  pagoAnticipadoRevertido: Result;
  deletingPagoAnticipado: boolean;
  deletingPagoAnticipadoError: string;
}

export interface GetTiposMembresiaOpciones {
  tiposMembresiaOpciones: Array<{ label: string; value: string }>;
  gettingTiposMembresiaOpciones: boolean;
  gettingTiposMembresiaOpcionesError: string;
}

export interface PutRegionMetas {
  metasRegionActualizadas: boolean;
  puttingRegionMetas: boolean;
  puttingRegionMetasError: string;
}

export interface PutClubMetas {
  metasClubActualizadas: boolean;
  puttingClubMetas: boolean;
  puttingClubMetasError: string;
}

export interface PutAsesoresMetas {
  metasAsesoresActualizadas: boolean;
  puttingAsesoresMetas: boolean;
  puttingAsesoresMetasError: string;
}

export interface GetComisionAlcanceByTipos {
  comisionesAlcance: ComisionAlcance[];
  gettingComisionesAlcance: boolean;
  gettingComisionesAlcanceError: string;
}

export interface GetSnapshot {
  snapshot: any;
  gettingSnapshot: boolean;
  gettingSnapshotError: string;
}

export interface PostSnapshotByPeriodo {
  postSnapshotResult: any;
  postingSnapshotByPeriodo: boolean;
  postingSnapshotByPeriodoError: string;
}

export interface PutSnapshotEvaluacion {
  putSnapshotEvaluacionResult: any;
  puttingSnapshotEvaluacion: boolean;
  puttingSnapshotEvaluacionError: string;
}

export interface DeleteSnapshotEvaluacion {
  deleteSnapshotEvaluacionResult: any;
  deletingSnapshotEvaluacion: boolean;
  deletingSnapshotEvaluacionError: string;
}

export interface GetResumen {
  resumenSnapshot: any;
  gettingResumenSnapshot: boolean;
  gettingResumenSnapshotError: string;
}

export interface PutCambiarVendedor {
  cambiarVendedorResult: any;
  puttingCambiarVendedor: boolean;
  puttingCambiarVendedorError: string;
}

export interface GetResumenAsesor {
  resumenAsesor: any;
  gettingResumenAsesor: boolean;
  gettingResumenAsesorError: string;
}

export interface GetLiderClubes {
  liderClubes: any[];
  gettingLiderClubes: boolean;
  gettingLiderClubesError: string;
}

export interface GetLiderReporte {
  liderReporte: any;
  gettingLiderReporte: boolean;
  gettingLiderReporteError: string;
}

export interface GetEstadoProceso {
  estadoProceso: MembresiaProceso;
  gettingEstadoProceso: boolean;
  gettingEstadoProcesoError: string;
}

export interface PostCalcularAlcances {
  calcularAlcancesResult: Result;
  postingCalcularAlcances: boolean;
  postingCalcularAlcancesError: string;
}

export interface PostConfirmarAlcances {
  confirmarAlcancesResult: Result;
  postingConfirmarAlcances: boolean;
  postingConfirmarAlcancesError: string;
}

export interface PostPrecalculo {
  precalculoResult: Result;
  postingPrecalculo: boolean;
  postingPrecalculoError: string;
}

export interface PostCalcularComisiones {
  calcularComisionesResult: Result;
  postingCalcularComisiones: boolean;
  postingCalcularComisionesError: string;
}

export interface DeleteCalcularAlcances {
  deleteCalcularAlcancesResult: Result;
  deletingCalcularAlcances: boolean;
  deletingCalcularAlcancesError: string;
}

export interface DeleteConfirmarAlcances {
  deleteConfirmarAlcancesResult: Result;
  deletingConfirmarAlcances: boolean;
  deletingConfirmarAlcancesError: string;
}

export interface DeletePrecalculo {
  deletePrecalculoResult: Result;
  deletingPrecalculo: boolean;
  deletingPrecalculoError: string;
}

export interface DeleteCalcularComisiones {
  deleteCalcularComisionesResult: Result;
  deletingCalcularComisiones: boolean;
  deletingCalcularComisionesError: string;
}

export interface GetMembresiaTracking {
  membresiaTracking: MembresiaTrackingClub[];
  gettingMembresiaTracking: boolean;
  gettingMembresiaTrackingError: string;
}

export interface PostMembresiaTracking {
  postMembresiaTrackingResult: Result;
  postingMembresiaTracking: boolean;
  postingMembresiaTrackingError: string;
}

export interface GetMembresiaTrackingClubAlcance {
  membresiaTrackingClubAlcance: MembresiaTrackingClubAlcance;
  gettingMembresiaTrackingClubAlcance: boolean;
  gettingMembresiaTrackingClubAlcanceError: string;
}

export interface PutMembresiaTrackingCompromisos {
  putMembresiaTrackingCompromisosResult: Result;
  puttingMembresiaTrackingCompromisos: boolean;
  puttingMembresiaTrackingCompromisosError: string;
}

export interface PutMembresiaTrackingAsesores {
  putMembresiaTrackingAsesoresResult: Result;
  puttingMembresiaTrackingAsesores: boolean;
  puttingMembresiaTrackingAsesoresError: string;
}

export interface PostIntegranteResolucion {
  postIntegranteResolucionResult: Result;
  postingIntegranteResolucion: boolean;
  postingIntegranteResolucionError: string;
}

export interface GetIntegranteCargosByFolio {
  integranteCargosByFolio: MembresiaIntegranteAlta[];
  gettingIntegranteCargosByFolio: boolean;
  gettingIntegranteCargosByFolioError: string;
}

export interface GetIntegrantesEliminados {
  integrantesEliminados: MembresiaIntegranteEliminado[];
  gettingIntegrantesEliminados: boolean;
  gettingIntegrantesEliminadosError: string;
}

export interface GetAltasEnMembresiasExistentes {
  altasEnMembresiasExistentes: MembresiaIntegranteAlta[];
  gettingAltasEnMembresiasExistentes: boolean;
  gettingAltasEnMembresiasExistentesError: string;
}

export interface PutReasignarCargoIntegrante {
  putReasignarCargoIntegranteResult: Result;
  puttingReasignarCargoIntegrante: boolean;
  puttingReasignarCargoIntegranteError: string;
}

export interface State
  extends PostComisionMembresiaCargaMetas,
    GetComisionMembresiaMetas,
    GetComisionMembresiaPlantilla,
    PostComisionMembresiaPlantilla,
    PostComisionMembresiaPlantillaConfirmar,
    DeleteComisionMembresiaPlantilla,
    PutRegionMetas,
    PutClubMetas,
    PutAsesoresMetas,
    GetComisionAlcanceByTipos,
    GetTiposMembresiaOpciones,
    GetSnapshot,
    PostSnapshotByPeriodo,
    PutSnapshotEvaluacion,
    DeleteSnapshotEvaluacion,
    GetResumen,
    PutCambiarVendedor,
    GetResumenAsesor,
    GetLiderClubes,
    GetLiderReporte,
    GetEstadoProceso,
    PostCalcularAlcances,
    PostConfirmarAlcances,
    PostPrecalculo,
    PostCalcularComisiones,
    DeleteCalcularAlcances,
    DeleteConfirmarAlcances,
    DeletePrecalculo,
    DeleteCalcularComisiones,
    GetMembresiaTracking,
    PostMembresiaTracking,
    GetMembresiaTrackingClubAlcance,
    PutMembresiaTrackingCompromisos,
    PutMembresiaTrackingAsesores,
    PostIntegranteResolucion,
    GetIntegranteCargosByFolio,
    GetIntegrantesEliminados,
    GetAltasEnMembresiasExistentes,
    PutReasignarCargoIntegrante {}

const initialState: State = {
  cargaMembresiaMeta: null,
  postingCargaMembresiaMeta: false,
  postingCargaMembresiaMetaError: null,
  comisionMembresiaMetas: null,
  gettingComisionMembresiaMetas: false,
  gettingComisionMembresiaMetasError: null,
  comisionMembresiaPlantilla: null,
  gettingComisionMembresiaPlantilla: false,
  gettingComisionMembresiaPlantillaError: null,
  plantillaGuardada: null,
  postingComisionMembresiaPlantilla: false,
  postingComisionMembresiaPlantillaError: null,
  plantillaConfirmada: false,
  postingComisionMembresiaPlantillaConfirmar: false,
  postingComisionMembresiaPlantillaConfirmarError: null,
  plantillaEliminada: false,
  deletingComisionMembresiaPlantilla: false,
  deletingComisionMembresiaPlantillaError: null,
  metasRegionActualizadas: false,
  puttingRegionMetas: false,
  puttingRegionMetasError: null,
  metasClubActualizadas: false,
  puttingClubMetas: false,
  puttingClubMetasError: null,
  metasAsesoresActualizadas: false,
  puttingAsesoresMetas: false,
  puttingAsesoresMetasError: null,
  comisionesAlcance: [],
  gettingComisionesAlcance: false,
  gettingComisionesAlcanceError: null,
  tiposMembresiaOpciones: [],
  gettingTiposMembresiaOpciones: false,
  gettingTiposMembresiaOpcionesError: null,
  snapshot: null,
  gettingSnapshot: false,
  gettingSnapshotError: null,
  postSnapshotResult: null,
  postingSnapshotByPeriodo: false,
  postingSnapshotByPeriodoError: null,
  putSnapshotEvaluacionResult: null,
  puttingSnapshotEvaluacion: false,
  puttingSnapshotEvaluacionError: null,
  deleteSnapshotEvaluacionResult: null,
  deletingSnapshotEvaluacion: false,
  deletingSnapshotEvaluacionError: null,
  resumenSnapshot: null,
  gettingResumenSnapshot: false,
  gettingResumenSnapshotError: null,
  cambiarVendedorResult: null,
  puttingCambiarVendedor: false,
  puttingCambiarVendedorError: null,
  resumenAsesor: null,
  gettingResumenAsesor: false,
  gettingResumenAsesorError: null,
  liderClubes: [],
  gettingLiderClubes: false,
  gettingLiderClubesError: null,
  liderReporte: null,
  gettingLiderReporte: false,
  gettingLiderReporteError: null,
  estadoProceso: null,
  gettingEstadoProceso: false,
  gettingEstadoProcesoError: null,
  calcularAlcancesResult: null,
  postingCalcularAlcances: false,
  postingCalcularAlcancesError: null,
  confirmarAlcancesResult: null,
  postingConfirmarAlcances: false,
  postingConfirmarAlcancesError: null,
  precalculoResult: null,
  postingPrecalculo: false,
  postingPrecalculoError: null,
  calcularComisionesResult: null,
  postingCalcularComisiones: false,
  postingCalcularComisionesError: null,
  deleteCalcularAlcancesResult: null,
  deletingCalcularAlcances: false,
  deletingCalcularAlcancesError: null,
  deleteConfirmarAlcancesResult: null,
  deletingConfirmarAlcances: false,
  deletingConfirmarAlcancesError: null,
  deletePrecalculoResult: null,
  deletingPrecalculo: false,
  deletingPrecalculoError: null,
  deleteCalcularComisionesResult: null,
  deletingCalcularComisiones: false,
  deletingCalcularComisionesError: null,
  membresiaTracking: [],
  gettingMembresiaTracking: false,
  gettingMembresiaTrackingError: null,
  postMembresiaTrackingResult: null,
  postingMembresiaTracking: false,
  postingMembresiaTrackingError: null,
  membresiaTrackingClubAlcance: null,
  gettingMembresiaTrackingClubAlcance: false,
  gettingMembresiaTrackingClubAlcanceError: null,
  putMembresiaTrackingCompromisosResult: null,
  puttingMembresiaTrackingCompromisos: false,
  puttingMembresiaTrackingCompromisosError: null,
  putMembresiaTrackingAsesoresResult: null,
  puttingMembresiaTrackingAsesores: false,
  puttingMembresiaTrackingAsesoresError: null,
  postIntegranteResolucionResult: null,
  postingIntegranteResolucion: false,
  postingIntegranteResolucionError: null,
  integranteCargosByFolio: null,
  gettingIntegranteCargosByFolio: false,
  gettingIntegranteCargosByFolioError: null,
  integrantesEliminados: null,
  gettingIntegrantesEliminados: false,
  gettingIntegrantesEliminadosError: null,
  altasEnMembresiasExistentes: null,
  gettingAltasEnMembresiasExistentes: false,
  gettingAltasEnMembresiasExistentesError: null,
  putReasignarCargoIntegranteResult: null,
  puttingReasignarCargoIntegrante: false,
  puttingReasignarCargoIntegranteError: null
};

export default function comisionMembresiaReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(state: State = initialState, action: IAction) {
  switch (action.type) {
    case `${actionTypes.POST_COMISION_MEMBRESIA_CARGA_METAS}_PENDING`: {
      return {
        postingCargaMembresiaMeta: true,
        postingCargaMembresiaMetaError: null
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_CARGA_METAS}_REJECTED`: {
      return {
        cargaMembresiaMeta: null,
        postingCargaMembresiaMeta: false,
        postingCargaMembresiaMetaError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_CARGA_METAS}_FULFILLED`: {
      return {
        cargaMembresiaMeta: action.payload.data,
        postingCargaMembresiaMeta: false,
        postingCargaMembresiaMetaError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_METAS}_PENDING`: {
      return {
        gettingComisionMembresiaMetas: true,
        gettingComisionMembresiaMetasError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_METAS}_REJECTED`: {
      return {
        comisionMembresiaMetas: null,
        gettingComisionMembresiaMetas: false,
        gettingComisionMembresiaMetasError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_METAS}_FULFILLED`: {
      return {
        comisionMembresiaMetas: action.payload.data,
        gettingComisionMembresiaMetas: false,
        gettingComisionMembresiaMetasError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_METAS_ACTUALES}_PENDING`: {
      return {
        gettingComisionMembresiaMetasActuales: true,
        gettingComisionMembresiaMetasActualesError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_METAS_ACTUALES}_REJECTED`: {
      return {
        comisionMembresiaMetasActuales: null,
        gettingComisionMembresiaMetasActuales: false,
        gettingComisionMembresiaMetasActualesError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_METAS_ACTUALES}_FULFILLED`: {
      return {
        comisionMembresiaMetasActuales: action.payload.data,
        gettingComisionMembresiaMetasActuales: false,
        gettingComisionMembresiaMetasActualesError: null
      };
    }

    case actionTypes.CLEAR_COMISION_MEMBRESIA_METAS: {
      return {
        cargaMembresiaMeta: null,
        comisionMembresiaMetasActuales: null,
        comisionMembresiaMetas: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_PLANTILLA}_PENDING`: {
      return {
        gettingComisionMembresiaPlantilla: true,
        gettingComisionMembresiaPlantillaError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_PLANTILLA}_REJECTED`: {
      return {
        comisionMembresiaPlantilla: null,
        gettingComisionMembresiaPlantilla: false,
        gettingComisionMembresiaPlantillaError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_PLANTILLA}_FULFILLED`: {
      return {
        comisionMembresiaPlantilla: action.payload.data,
        gettingComisionMembresiaPlantilla: false,
        gettingComisionMembresiaPlantillaError: null
      };
    }

    case `${actionTypes.POST_COMISION_MEMBRESIA_PLANTILLA}_PENDING`: {
      return {
        postingComisionMembresiaPlantilla: true,
        postingComisionMembresiaPlantillaError: null
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_PLANTILLA}_REJECTED`: {
      return {
        plantillaGuardada: null,
        postingComisionMembresiaPlantilla: false,
        postingComisionMembresiaPlantillaError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_PLANTILLA}_FULFILLED`: {
      return {
        plantillaGuardada: action.payload.data,
        postingComisionMembresiaPlantilla: false,
        postingComisionMembresiaPlantillaError: null
      };
    }

    case `${actionTypes.POST_COMISION_MEMBRESIA_PLANTILLA_CONFIRMAR}_PENDING`: {
      return {
        postingComisionMembresiaPlantillaConfirmar: true,
        postingComisionMembresiaPlantillaConfirmarError: null
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_PLANTILLA_CONFIRMAR}_REJECTED`: {
      return {
        plantillaConfirmada: false,
        postingComisionMembresiaPlantillaConfirmar: false,
        postingComisionMembresiaPlantillaConfirmarError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_PLANTILLA_CONFIRMAR}_FULFILLED`: {
      return {
        plantillaConfirmada: true,
        postingComisionMembresiaPlantillaConfirmar: false,
        postingComisionMembresiaPlantillaConfirmarError: null
      };
    }

    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PLANTILLA}_PENDING`: {
      return {
        deletingComisionMembresiaPlantilla: true,
        deletingComisionMembresiaPlantillaError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PLANTILLA}_REJECTED`: {
      return {
        plantillaEliminada: false,
        deletingComisionMembresiaPlantilla: false,
        deletingComisionMembresiaPlantillaError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PLANTILLA}_FULFILLED`: {
      return {
        plantillaEliminada: true,
        deletingComisionMembresiaPlantilla: false,
        deletingComisionMembresiaPlantillaError: null
      };
    }

    case `${actionTypes.PUT_COMISION_MEMBRESIA_REGION_METAS}_PENDING`: {
      return {
        puttingRegionMetas: true,
        puttingRegionMetasError: null
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_REGION_METAS}_REJECTED`: {
      return {
        metasRegionActualizadas: false,
        puttingRegionMetas: false,
        puttingRegionMetasError: readMessageBack(action)
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_REGION_METAS}_FULFILLED`: {
      return {
        metasRegionActualizadas: true,
        puttingRegionMetas: false,
        puttingRegionMetasError: null
      };
    }

    case `${actionTypes.PUT_COMISION_MEMBRESIA_CLUB_METAS}_PENDING`: {
      return {
        puttingClubMetas: true,
        puttingClubMetasError: null
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_CLUB_METAS}_REJECTED`: {
      return {
        metasClubActualizadas: false,
        puttingClubMetas: false,
        puttingClubMetasError: readMessageBack(action)
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_CLUB_METAS}_FULFILLED`: {
      return {
        metasClubActualizadas: true,
        puttingClubMetas: false,
        puttingClubMetasError: null
      };
    }

    case `${actionTypes.PUT_COMISION_MEMBRESIA_ASESORES_METAS}_PENDING`: {
      return {
        puttingAsesoresMetas: true,
        puttingAsesoresMetasError: null
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_ASESORES_METAS}_REJECTED`: {
      return {
        metasAsesoresActualizadas: false,
        puttingAsesoresMetas: false,
        puttingAsesoresMetasError: readMessageBack(action)
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_ASESORES_METAS}_FULFILLED`: {
      return {
        metasAsesoresActualizadas: true,
        puttingAsesoresMetas: false,
        puttingAsesoresMetasError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_ALCANCES}_PENDING`: {
      return {
        gettingComisionesAlcance: true,
        gettingComisionesAlcanceError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_ALCANCES}_REJECTED`: {
      return {
        comisionesAlcance: [],
        gettingComisionesAlcance: false,
        gettingComisionesAlcanceError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_ALCANCES}_FULFILLED`: {
      return {
        comisionesAlcance: action.payload.data,
        gettingComisionesAlcance: false,
        gettingComisionesAlcanceError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_TIPOS_MEMBRESIA_OPCIONES}_PENDING`: {
      return {
        gettingTiposMembresiaOpciones: true,
        gettingTiposMembresiaOpcionesError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_TIPOS_MEMBRESIA_OPCIONES}_REJECTED`: {
      return {
        tiposMembresiaOpciones: [],
        gettingTiposMembresiaOpciones: false,
        gettingTiposMembresiaOpcionesError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_TIPOS_MEMBRESIA_OPCIONES}_FULFILLED`: {
      return {
        tiposMembresiaOpciones: action.payload.data,
        gettingTiposMembresiaOpciones: false,
        gettingTiposMembresiaOpcionesError: null
      };
    }

    case `${actionTypes.CLEAR_COMISION_MEMBRESIA_SNAPSHOT}`: {
      return {
        snapshot: null,
        gettingSnapshot: false,
        gettingSnapshotError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_SNAPSHOT_BY_FOLIO}_PENDING`: {
      return {
        gettingSnapshot: true,
        gettingSnapshotError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_SNAPSHOT_BY_FOLIO}_REJECTED`: {
      return {
        snapshot: null,
        gettingSnapshot: false,
        gettingSnapshotError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_SNAPSHOT_BY_FOLIO}_FULFILLED`: {
      return {
        snapshot: action.payload.data,
        gettingSnapshot: false,
        gettingSnapshotError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_SNAPSHOT_BY_PERIODO}_PENDING`: {
      return {
        gettingSnapshot: true,
        gettingSnapshotError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_SNAPSHOT_BY_PERIODO}_REJECTED`: {
      return {
        snapshot: null,
        gettingSnapshot: false,
        gettingSnapshotError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_SNAPSHOT_BY_PERIODO}_FULFILLED`: {
      return {
        snapshot: action.payload.data,
        gettingSnapshot: false,
        gettingSnapshotError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_SNAPSHOT_BY_ASESOR}_PENDING`: {
      return {
        gettingSnapshot: true,
        gettingSnapshotError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_SNAPSHOT_BY_ASESOR}_REJECTED`: {
      return {
        snapshot: null,
        gettingSnapshot: false,
        gettingSnapshotError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_SNAPSHOT_BY_ASESOR}_FULFILLED`: {
      return {
        snapshot: action.payload.data,
        gettingSnapshot: false,
        gettingSnapshotError: null
      };
    }

    case `${actionTypes.POST_COMISION_MEMBRESIA_SNAPSHOT_BY_PERIODO}_PENDING`: {
      return {
        postingSnapshotByPeriodo: true,
        postingSnapshotByPeriodoError: null
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_SNAPSHOT_BY_PERIODO}_REJECTED`: {
      return {
        postSnapshotResult: null,
        postingSnapshotByPeriodo: false,
        postingSnapshotByPeriodoError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_SNAPSHOT_BY_PERIODO}_FULFILLED`: {
      return {
        postSnapshotResult: action.payload.data,
        postingSnapshotByPeriodo: false,
        postingSnapshotByPeriodoError: null
      };
    }

    case `${actionTypes.PUT_COMISION_MEMBRESIA_SNAPSHOT_EVALUACION}_PENDING`: {
      return {
        puttingSnapshotEvaluacion: true,
        puttingSnapshotEvaluacionError: null
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_SNAPSHOT_EVALUACION}_REJECTED`: {
      return {
        putSnapshotEvaluacionResult: null,
        puttingSnapshotEvaluacion: false,
        puttingSnapshotEvaluacionError: readMessageBack(action)
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_SNAPSHOT_EVALUACION}_FULFILLED`: {
      return {
        putSnapshotEvaluacionResult: action.payload.data,
        puttingSnapshotEvaluacion: false,
        puttingSnapshotEvaluacionError: null
      };
    }

    case `${actionTypes.DELETE_COMISION_MEMBRESIA_SNAPSHOT_EVALUACION}_PENDING`: {
      return {
        deletingSnapshotEvaluacion: true,
        deletingSnapshotEvaluacionError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_SNAPSHOT_EVALUACION}_REJECTED`: {
      return {
        deleteSnapshotEvaluacionResult: null,
        deletingSnapshotEvaluacion: false,
        deletingSnapshotEvaluacionError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_SNAPSHOT_EVALUACION}_FULFILLED`: {
      return {
        deleteSnapshotEvaluacionResult: action.payload.data,
        deletingSnapshotEvaluacion: false,
        deletingSnapshotEvaluacionError: null
      };
    }

    case `${actionTypes.CLEAR_COMISION_MEMBRESIA_RESUMEN}`: {
      return {
        resumenSnapshot: null,
        gettingResumenSnapshot: false,
        gettingResumenSnapshotError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_RESUMEN_BY_PERIODO}_PENDING`: {
      return {
        gettingResumenSnapshot: true,
        gettingResumenSnapshotError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_RESUMEN_BY_PERIODO}_REJECTED`: {
      return {
        resumenSnapshot: null,
        gettingResumenSnapshot: false,
        gettingResumenSnapshotError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_RESUMEN_BY_PERIODO}_FULFILLED`: {
      return {
        resumenSnapshot: action.payload.data,
        gettingResumenSnapshot: false,
        gettingResumenSnapshotError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_RESUMEN_BY_PERIODO_CLUB}_PENDING`: {
      return {
        gettingResumenSnapshot: true,
        gettingResumenSnapshotError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_RESUMEN_BY_PERIODO_CLUB}_REJECTED`: {
      return {
        resumenSnapshot: null,
        gettingResumenSnapshot: false,
        gettingResumenSnapshotError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_RESUMEN_BY_PERIODO_CLUB}_FULFILLED`: {
      return {
        resumenSnapshot: action.payload.data,
        gettingResumenSnapshot: false,
        gettingResumenSnapshotError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_RESUMEN_BY_ASESOR}_PENDING`: {
      return {
        gettingResumenAsesor: true,
        gettingResumenAsesorError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_RESUMEN_BY_ASESOR}_REJECTED`: {
      return {
        resumenAsesor: null,
        gettingResumenAsesor: false,
        gettingResumenAsesorError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_RESUMEN_BY_ASESOR}_FULFILLED`: {
      return {
        resumenAsesor: action.payload.data,
        gettingResumenAsesor: false,
        gettingResumenAsesorError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_LIDER_CLUBES}_PENDING`: {
      return {
        gettingLiderClubes: true,
        gettingLiderClubesError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_LIDER_CLUBES}_REJECTED`: {
      return {
        liderClubes: [],
        gettingLiderClubes: false,
        gettingLiderClubesError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_LIDER_CLUBES}_FULFILLED`: {
      return {
        liderClubes: action.payload.data,
        gettingLiderClubes: false,
        gettingLiderClubesError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_LIDER_REPORTE}_PENDING`: {
      return {
        gettingLiderReporte: true,
        gettingLiderReporteError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_LIDER_REPORTE}_REJECTED`: {
      return {
        liderReporte: null,
        gettingLiderReporte: false,
        gettingLiderReporteError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_LIDER_REPORTE}_FULFILLED`: {
      return {
        liderReporte: action.payload.data,
        gettingLiderReporte: false,
        gettingLiderReporteError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_PROCESO_ESTADO}_PENDING`: {
      return {
        gettingEstadoProceso: true,
        gettingEstadoProcesoError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_PROCESO_ESTADO}_REJECTED`: {
      return {
        estadoProceso: null,
        gettingEstadoProceso: false,
        gettingEstadoProcesoError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_PROCESO_ESTADO}_FULFILLED`: {
      return {
        estadoProceso: action.payload.data,
        gettingEstadoProceso: false,
        gettingEstadoProcesoError: null
      };
    }

    case `${actionTypes.POST_COMISION_MEMBRESIA_PROCESO_CALCULAR_ALCANCES}_PENDING`: {
      return {
        postingCalcularAlcances: true,
        postingCalcularAlcancesError: null
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_PROCESO_CALCULAR_ALCANCES}_REJECTED`: {
      return {
        calcularAlcancesResult: null,
        postingCalcularAlcances: false,
        postingCalcularAlcancesError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_PROCESO_CALCULAR_ALCANCES}_FULFILLED`: {
      return {
        calcularAlcancesResult: action.payload.data,
        postingCalcularAlcances: false,
        postingCalcularAlcancesError: null
      };
    }

    case `${actionTypes.POST_COMISION_MEMBRESIA_PROCESO_CONFIRMAR_ALCANCES}_PENDING`: {
      return {
        postingConfirmarAlcances: true,
        postingConfirmarAlcancesError: null
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_PROCESO_CONFIRMAR_ALCANCES}_REJECTED`: {
      return {
        confirmarAlcancesResult: null,
        postingConfirmarAlcances: false,
        postingConfirmarAlcancesError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_PROCESO_CONFIRMAR_ALCANCES}_FULFILLED`: {
      return {
        confirmarAlcancesResult: action.payload.data,
        postingConfirmarAlcances: false,
        postingConfirmarAlcancesError: null
      };
    }

    case `${actionTypes.POST_COMISION_MEMBRESIA_PROCESO_PRECALCULO}_PENDING`: {
      return {
        postingPrecalculo: true,
        postingPrecalculoError: null
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_PROCESO_PRECALCULO}_REJECTED`: {
      return {
        precalculoResult: null,
        postingPrecalculo: false,
        postingPrecalculoError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_PROCESO_PRECALCULO}_FULFILLED`: {
      return {
        precalculoResult: action.payload.data,
        postingPrecalculo: false,
        postingPrecalculoError: null
      };
    }

    case `${actionTypes.POST_COMISION_MEMBRESIA_PROCESO_CALCULAR_COMISIONES}_PENDING`: {
      return {
        postingCalcularComisiones: true,
        postingCalcularComisionesError: null
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_PROCESO_CALCULAR_COMISIONES}_REJECTED`: {
      return {
        calcularComisionesResult: null,
        postingCalcularComisiones: false,
        postingCalcularComisionesError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_PROCESO_CALCULAR_COMISIONES}_FULFILLED`: {
      return {
        calcularComisionesResult: action.payload.data,
        postingCalcularComisiones: false,
        postingCalcularComisionesError: null
      };
    }

    case `${actionTypes.PUT_COMISION_MEMBRESIA_CAMBIAR_VENDEDOR}_PENDING`: {
      return {
        puttingCambiarVendedor: true,
        puttingCambiarVendedorError: null
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_CAMBIAR_VENDEDOR}_REJECTED`: {
      return {
        cambiarVendedorResult: null,
        puttingCambiarVendedor: false,
        puttingCambiarVendedorError: readMessageBack(action)
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_CAMBIAR_VENDEDOR}_FULFILLED`: {
      return {
        cambiarVendedorResult: action.payload.data,
        puttingCambiarVendedor: false,
        puttingCambiarVendedorError: null
      };
    }

    // Empleados dados de baja
    case `${actionTypes.GET_COMISION_MEMBRESIA_EMPLEADOS_BAJA}_PENDING`: {
      return {
        gettingEmpleadosDadosDeBaja: true,
        gettingEmpleadosDadosDeBajaError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_EMPLEADOS_BAJA}_REJECTED`: {
      return {
        empleadosDadosDeBaja: null,
        gettingEmpleadosDadosDeBaja: false,
        gettingEmpleadosDadosDeBajaError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_EMPLEADOS_BAJA}_FULFILLED`: {
      return {
        empleadosDadosDeBaja: action.payload.data,
        gettingEmpleadosDadosDeBaja: false,
        gettingEmpleadosDadosDeBajaError: null
      };
    }

    // Revertir pago anticipado
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PAGO_ANTICIPADO}_PENDING`: {
      return {
        deletingPagoAnticipado: true,
        deletingPagoAnticipadoError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PAGO_ANTICIPADO}_REJECTED`: {
      return {
        pagoAnticipadoRevertido: null,
        deletingPagoAnticipado: false,
        deletingPagoAnticipadoError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PAGO_ANTICIPADO}_FULFILLED`: {
      return {
        pagoAnticipadoRevertido: action.payload.data,
        deletingPagoAnticipado: false,
        deletingPagoAnticipadoError: null
      };
    }

    // Revertir cálculo de alcances
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_CALCULAR_ALCANCES}_PENDING`: {
      return {
        deletingCalcularAlcances: true,
        deletingCalcularAlcancesError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_CALCULAR_ALCANCES}_REJECTED`: {
      return {
        deleteCalcularAlcancesResult: null,
        deletingCalcularAlcances: false,
        deletingCalcularAlcancesError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_CALCULAR_ALCANCES}_FULFILLED`: {
      return {
        deleteCalcularAlcancesResult: action.payload.data,
        deletingCalcularAlcances: false,
        deletingCalcularAlcancesError: null
      };
    }

    // Revertir confirmación de alcances
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_CONFIRMAR_ALCANCES}_PENDING`: {
      return {
        deletingConfirmarAlcances: true,
        deletingConfirmarAlcancesError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_CONFIRMAR_ALCANCES}_REJECTED`: {
      return {
        deleteConfirmarAlcancesResult: null,
        deletingConfirmarAlcances: false,
        deletingConfirmarAlcancesError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_CONFIRMAR_ALCANCES}_FULFILLED`: {
      return {
        deleteConfirmarAlcancesResult: action.payload.data,
        deletingConfirmarAlcances: false,
        deletingConfirmarAlcancesError: null
      };
    }

    // Revertir precálculo
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_PRECALCULO}_PENDING`: {
      return {
        deletingPrecalculo: true,
        deletingPrecalculoError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_PRECALCULO}_REJECTED`: {
      return {
        deletePrecalculoResult: null,
        deletingPrecalculo: false,
        deletingPrecalculoError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_PRECALCULO}_FULFILLED`: {
      return {
        deletePrecalculoResult: action.payload.data,
        deletingPrecalculo: false,
        deletingPrecalculoError: null
      };
    }

    // Revertir cálculo de comisiones
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_CALCULAR_COMISIONES}_PENDING`: {
      return {
        deletingCalcularComisiones: true,
        deletingCalcularComisionesError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_CALCULAR_COMISIONES}_REJECTED`: {
      return {
        deleteCalcularComisionesResult: null,
        deletingCalcularComisiones: false,
        deletingCalcularComisionesError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_CALCULAR_COMISIONES}_FULFILLED`: {
      return {
        deleteCalcularComisionesResult: action.payload.data,
        deletingCalcularComisiones: false,
        deletingCalcularComisionesError: null
      };
    }

    // Obtener tracking por periodo
    case `${actionTypes.GET_COMISION_MEMBRESIA_TRACKING}_PENDING`: {
      return {
        gettingMembresiaTracking: true,
        gettingMembresiaTrackingError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_TRACKING}_REJECTED`: {
      return {
        membresiaTracking: [],
        gettingMembresiaTracking: false,
        gettingMembresiaTrackingError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_TRACKING}_FULFILLED`: {
      return {
        membresiaTracking: action.payload.data,
        gettingMembresiaTracking: false,
        gettingMembresiaTrackingError: null
      };
    }

    // Guardar tracking
    case `${actionTypes.POST_COMISION_MEMBRESIA_TRACKING}_PENDING`: {
      return {
        postingMembresiaTracking: true,
        postingMembresiaTrackingError: null
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_TRACKING}_REJECTED`: {
      return {
        postMembresiaTrackingResult: null,
        postingMembresiaTracking: false,
        postingMembresiaTrackingError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_TRACKING}_FULFILLED`: {
      return {
        postMembresiaTrackingResult: action.payload.data,
        postingMembresiaTracking: false,
        postingMembresiaTrackingError: null
      };
    }

    // Limpiar tracking
    case actionTypes.CLEAR_COMISION_MEMBRESIA_TRACKING: {
      return {
        membresiaTracking: [],
        gettingMembresiaTracking: false,
        gettingMembresiaTrackingError: null,
        postMembresiaTrackingResult: null,
        postingMembresiaTracking: false,
        postingMembresiaTrackingError: null
      };
    }

    // Obtener tracking club alcance
    case `${actionTypes.GET_COMISION_MEMBRESIA_TRACKING_CLUB_ALCANCE}_PENDING`: {
      return {
        gettingMembresiaTrackingClubAlcance: true,
        gettingMembresiaTrackingClubAlcanceError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_TRACKING_CLUB_ALCANCE}_REJECTED`: {
      return {
        membresiaTrackingClubAlcance: null,
        gettingMembresiaTrackingClubAlcance: false,
        gettingMembresiaTrackingClubAlcanceError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_TRACKING_CLUB_ALCANCE}_FULFILLED`: {
      return {
        membresiaTrackingClubAlcance: action.payload.data,
        gettingMembresiaTrackingClubAlcance: false,
        gettingMembresiaTrackingClubAlcanceError: null
      };
    }

    // Guardar compromisos club
    case `${actionTypes.PUT_COMISION_MEMBRESIA_TRACKING_COMPROMISOS}_PENDING`: {
      return {
        puttingMembresiaTrackingCompromisos: true,
        puttingMembresiaTrackingCompromisosError: null
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_TRACKING_COMPROMISOS}_REJECTED`: {
      return {
        putMembresiaTrackingCompromisosResult: null,
        puttingMembresiaTrackingCompromisos: false,
        puttingMembresiaTrackingCompromisosError: readMessageBack(action)
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_TRACKING_COMPROMISOS}_FULFILLED`: {
      return {
        putMembresiaTrackingCompromisosResult: action.payload.data,
        puttingMembresiaTrackingCompromisos: false,
        puttingMembresiaTrackingCompromisosError: null
      };
    }

    // Guardar asesores tracking
    case `${actionTypes.PUT_COMISION_MEMBRESIA_TRACKING_ASESORES}_PENDING`: {
      return {
        puttingMembresiaTrackingAsesores: true,
        puttingMembresiaTrackingAsesoresError: null
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_TRACKING_ASESORES}_REJECTED`: {
      return {
        putMembresiaTrackingAsesoresResult: null,
        puttingMembresiaTrackingAsesores: false,
        puttingMembresiaTrackingAsesoresError: readMessageBack(action)
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_TRACKING_ASESORES}_FULFILLED`: {
      return {
        putMembresiaTrackingAsesoresResult: action.payload.data,
        puttingMembresiaTrackingAsesores: false,
        puttingMembresiaTrackingAsesoresError: null
      };
    }

    // Resoluciones de altas de integrantes
    case `${actionTypes.POST_COMISION_MEMBRESIA_INTEGRANTE_RESOLUCION}_PENDING`: {
      return {
        postingIntegranteResolucion: true,
        postingIntegranteResolucionError: null
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_INTEGRANTE_RESOLUCION}_REJECTED`: {
      return {
        postIntegranteResolucionResult: null,
        postingIntegranteResolucion: false,
        postingIntegranteResolucionError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_MEMBRESIA_INTEGRANTE_RESOLUCION}_FULFILLED`: {
      return {
        postIntegranteResolucionResult: action.payload.data,
        postingIntegranteResolucion: false,
        postingIntegranteResolucionError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_INTEGRANTE_CARGOS_BY_FOLIO}_PENDING`: {
      return {
        gettingIntegranteCargosByFolio: true,
        gettingIntegranteCargosByFolioError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_INTEGRANTE_CARGOS_BY_FOLIO}_REJECTED`: {
      return {
        integranteCargosByFolio: null,
        gettingIntegranteCargosByFolio: false,
        gettingIntegranteCargosByFolioError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_INTEGRANTE_CARGOS_BY_FOLIO}_FULFILLED`: {
      return {
        integranteCargosByFolio: action.payload.data,
        gettingIntegranteCargosByFolio: false,
        gettingIntegranteCargosByFolioError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_INTEGRANTE_ELIMINADOS}_PENDING`: {
      return {
        gettingIntegrantesEliminados: true,
        gettingIntegrantesEliminadosError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_INTEGRANTE_ELIMINADOS}_REJECTED`: {
      return {
        integrantesEliminados: [],
        gettingIntegrantesEliminados: false,
        gettingIntegrantesEliminadosError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_INTEGRANTE_ELIMINADOS}_FULFILLED`: {
      return {
        integrantesEliminados: action.payload.data,
        gettingIntegrantesEliminados: false,
        gettingIntegrantesEliminadosError: null
      };
    }

    case `${actionTypes.GET_COMISION_MEMBRESIA_INTEGRANTE_ALTAS_EXISTENTES}_PENDING`: {
      return {
        gettingAltasEnMembresiasExistentes: true,
        gettingAltasEnMembresiasExistentesError: null
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_INTEGRANTE_ALTAS_EXISTENTES}_REJECTED`: {
      return {
        altasEnMembresiasExistentes: null,
        gettingAltasEnMembresiasExistentes: false,
        gettingAltasEnMembresiasExistentesError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_MEMBRESIA_INTEGRANTE_ALTAS_EXISTENTES}_FULFILLED`: {
      return {
        altasEnMembresiasExistentes: action.payload.data,
        gettingAltasEnMembresiasExistentes: false,
        gettingAltasEnMembresiasExistentesError: null
      };
    }

    case `${actionTypes.PUT_COMISION_MEMBRESIA_INTEGRANTE_REASIGNAR}_PENDING`: {
      return {
        puttingReasignarCargoIntegrante: true,
        puttingReasignarCargoIntegranteError: null
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_INTEGRANTE_REASIGNAR}_REJECTED`: {
      return {
        putReasignarCargoIntegranteResult: null,
        puttingReasignarCargoIntegrante: false,
        puttingReasignarCargoIntegranteError: readMessageBack(action)
      };
    }
    case `${actionTypes.PUT_COMISION_MEMBRESIA_INTEGRANTE_REASIGNAR}_FULFILLED`: {
      return {
        putReasignarCargoIntegranteResult: action.payload.data,
        puttingReasignarCargoIntegrante: false,
        puttingReasignarCargoIntegranteError: null
      };
    }

    case actionTypes.CLEAR_COMISION_MEMBRESIA_INTEGRANTE_RESOLUCION: {
      return {
        postIntegranteResolucionResult: null,
        integranteCargosByFolio: null,
        integrantesEliminados: null,
        altasEnMembresiasExistentes: null,
        putReasignarCargoIntegranteResult: null
      };
    }

    default:
      return state;
  }
}
